<script>
import { ArrowUpIcon, VideoIcon,  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon, } from "vue-feather-icons";
import { Carousel, Slide } from "vue-carousel";
import countTo from "vue-count-to";

import Navbar from "@/components/navbar";
import Features from "@/components/features";
import Footer from "@/components/footer";
import axios from "axios";
import config from "@/config.json";
import {post} from "@/assets/js/utils";

/**
 * Index-services component
 */
export default {
  data() {
    const ua = navigator.userAgent.toLowerCase();
    const os = ua.indexOf("mac") > 0? 'mac' : 'win';
    const videoUrl = (os === 'mac')? 'https://mirror-web.oss-cn-shanghai.aliyuncs.com/video/mac-xd-installation.mp4' : 'https://mirror-web.oss-cn-shanghai.aliyuncs.com/video/win-xd-installation.mp4';
    return {
      playing: false,
      pause: false,
      videoUrl: videoUrl,
      downloadUrl: "#",
      os : os,
      selected: os,
      release: {
        app: "",
        vcname: "",
        vc: 0,
        mac_url: "",
        win_url: "",
        created_at: "",
      }
    };
  },
  mounted() {
    this.getRelease();
  },
  methods: {
    async getRelease() {
      try {
        const data = await  post(`${config.api.latestrelease}`, {app: "Desktop.Mirror"});
        if (data.errno === 0) {
          this.release = data.data;
          this.downloadUrl = (this.selected === "mac")? this.release.mac_url : this.release.win_url;
            document.getElementById('download-url').href = this.downloadUrl;
        } else {
        }
      } catch (e) {}
    },
    toggleOS() {
      this.selected = (this.selected === "mac")? "win" : "mac";
      this.downloadUrl = (this.selected === "mac")? this.release.mac_url : this.release.win_url;
    },
    play() {
      this.playing = true;
      this.pause = false;
      this.$nextTick(() => {
        this.$refs.player.play();
      });
    },
    togglePlay() {
      this.pause = !this.pause;
      this.$nextTick(() => {
        if (this.$refs.player.paused) {
          this.$refs.player.play();
        } else {
          this.$refs.player.pause();
        }
      });
    },
  },
  components: {
    Navbar,
    Carousel,
    Slide,
    ArrowUpIcon,
    VideoIcon,
      FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon,
    countTo,
    Footer,
    Features
  },
};
</script>

<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <section class="bg-half-170 d-table w-100" id="home">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7 col-md-7">
            <div class="title-heading mt-4">
              <h1 class="heading mb-3"> {{$t('xd.title')}} </h1>
              <p class="para-desc text-muted">{{$t('xd.description')}} </p>
                <div class="mt-4 pt-2">
                    <h2 class="h3">{{$t('xd.install.title')}}</h2>
                    <ul class="list-unstyled">
                        <li v-for="(item, index) in $t('xd.install.steps')">
                            <span class="text-primary h5 mr-2"><i class="uil uil-check-circle align-middle"></i></span>
                            <span v-html="item"></span>
                        </li>
                    </ul>
                </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
            <img loading="eager" fetchpriority="high" src="/images/photoshop/xd-main.png" :alt="$t('alt.xd_panel')" width="700" />
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->

    <!-- counter Start -->
    <section class="section bg-light">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <h2 class="h4 title mb-4">{{$t('photoshop.install.title')}}</h2>
              <p class="text-muted para-desc mx-auto mb-0">{{$t('photoshop.install.description')}} </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

        <div class="row justify-content-center mt-4">
          <div class="col-9 text-center">
            <div
                class="video-solution-cta position-relative"
                style="z-index: 1"
            >
              <div class="position-relative">
                <video @click="togglePlay" v-if="playing" ref="player" :src="videoUrl"></video>
                <img width="1920" height="1080" loading="lazy" v-else src="/images/index/video-cover1.png" class="img-fluid" :alt="$t('alt.video_cover')" />
                <div v-if="!playing || pause" class="play-icon">
                  <a href="#" @click.prevent="play" class="play-btn video-play-icon" >
                    <i class="mdi mdi-play text-primary rounded-circle bg-white shadow-lg" ></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row -->
      </div>
      <!--end container-->

    </section>
    <!--end section-->
    <!-- counter End -->

    <!--end section-->

    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>

sstyle>
</style>
